import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { RoleService } from '../../services/role.service';
import { Transition } from '@uirouter/core';

export const FiRoleStateResolveRole = [FiStateService, RoleService, Transition, FiRoleStateResolveRoleResolveFunc];

export function FiRoleStateResolveRoleResolveFunc(
    fiStateService: FiStateService,
    roleService: RoleService,
    tr: Transition,
) {
    return roleService.getRole(fiStateService.getParams(tr).Id);
}

export const FiRoleStateResolveRoleEdit = [
    FiStateService,
    RoleService,
    Transition,
    FiRoleStateResolveRoleResolveEditFunc,
];

export function FiRoleStateResolveRoleResolveEditFunc(
    fiStateService: FiStateService,
    roleService: RoleService,
    tr: Transition,
) {
    return roleService.getRole(fiStateService.getParams(tr).Id, false);
}
